import React, { useState, useEffect, Fragment } from "react"

import ServiceRow from "../ServiceRow"

import { GetSearchedServices } from "../../apis/VenuesAPI"
import DropDownSorting from "../ServicesSection/DropDownSorting"

import style from "./index.module.sass"

const MIN_SEARCH_CHARS = 3

function ShowSearchResults(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    query,
    venueId,
    onServiceClick,
    orderingEnabled,
    sortFunction = null,
    handleSort,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [results, setResults] = useState([])

  useEffect(() => {
    if (!query || query.length < MIN_SEARCH_CHARS) {
      return
    }

    search(query)
  }, [query])

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  const search = (term) => {
    GetSearchedServices(term, [venueId]).then((data) => {
      const { dishes } = data

      // TODO: console.log("Todo: add support for: serviceSectionPartConfigs")
      setResults(dishes)
    })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let availableServices = [...results]

  if (!!sortFunction) {
    availableServices.sort(sortFunction.sortHandler)
  }

  // -------------------------------------

  return (
    <Fragment>
      <div className={style.headingContainer}>
        <div className={style.copyContainer}>
          <h3 className={style.title}>
            {I18n.t("service_ordering.search_results_title")}
          </h3>

          <p className={style.subtitle}>
            {I18n.t("service_ordering.search_results_title_count", {
              count: results?.length || 0,
            })}
          </p>
        </div>
        <DropDownSorting sortFunction={sortFunction} handleSort={handleSort} />
      </div>

      <div className={style.servicesContainer}>
        {availableServices.map((service) => {
          return (
            <ServiceRow
              key={service.id}
              service={service}
              serviceSectionPartConfigs={[]}
              orderingEnabled={orderingEnabled}
              onShowModal={onServiceClick}
            />
          )
        })}
        {/* Prevent last line elements to grow without control */}
        {/* Actually the only working work-around to this flex lack */}
        <div className={style.lastCard}></div>
        <div className={style.lastCard}></div>
        <div className={style.lastCard}></div>
      </div>
    </Fragment>
  )
}

// ----------------------------------------------------------------------------

export default ShowSearchResults
